export const tabBkgColor = {
  disabled: "#b9b9b9",
  completed: "#87ff87",
  incomplete: "#ffa3a385",
  normal: "white",
};

export function notingroup(i) {
  return i.group_id === "" || i.group_id === undefined || i.group_id === null;
}

export function ingroup(i) {
  return i.group_id !== "" && i.group_id !== undefined && i.group_id !== null;
}

export const reactTourSteps = [
  {
    selector: ".club-parent",
    content: "You can select a community of which you are a part of from here",
  },
  {
    selector: ".season-parent",
    content:
      "Here you can select the season listed by the Admin(s) of the community",
  },
  {
    selector: ".challenge-details-row2",
    content:
      "The challenges of the selected season will be displayed here. You can choose them to view the details and participate in them.",
  },
  {
    selector: ".specific-challenge-detail-parent",
    content:
      "You can see the details of the selected challenge here. You can enter your activity data of the given task(s)/event(s) of the challenge from here.",
  },
  {
    selector: ".specific-challenge-detail-body",
    content: "You can see the activities and tasks for the selected date",
  },
  {
    selector: ".specific-challenge-detail-body>.right-body",
    content:
      "Click here to enter your activity data for the selected task/event",
  },
];
